import i18n from "../../i18n";
import { HealthPlan } from "../../model/business/HealthPlan";

const API_URL = process.env.REACT_APP_BUSINESS_SERVICE_BASE_URL || '';

const headers = (token: string) => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    "Accept-Language": i18n.language || "pt",
});

/** Health plans (convênios) the business accepts. Listing is open to any member. */
export async function getBusinessHealthPlans(
    businessId: number | string,
    token: string
): Promise<HealthPlan[]> {
    const query = `
        query businessHealthPlans($businessId: ID!) {
            businessHealthPlans(businessId: $businessId) {
                id businessId name active
            }
        }
    `;
    const res = await fetch(API_URL, {
        method: "POST",
        headers: headers(token),
        body: JSON.stringify({ query, variables: { businessId } }),
    });
    const json = await res.json();
    if (json.errors) {
        throw new Error(json.errors.map((e: { message?: string }) => e?.message ?? String(e)).join('; '));
    }
    return json.data?.businessHealthPlans ?? [];
}

/**
 * Create (idempotent by name) or update a health plan. Gated by BUSINESS_SETTINGS
 * on the backend. Returns the saved plan.
 */
export async function saveHealthPlan(
    input: { id?: string; businessId: number | string; name: string; active?: boolean },
    token: string
): Promise<HealthPlan> {
    const mutation = `
        mutation saveHealthPlan($input: HealthPlanInput!) {
            saveHealthPlan(input: $input) {
                id businessId name active
            }
        }
    `;
    const res = await fetch(API_URL, {
        method: "POST",
        headers: headers(token),
        body: JSON.stringify({ query: mutation, variables: { input } }),
    });
    const json = await res.json();
    if (json.errors) {
        throw new Error(json.errors.map((e: { message?: string }) => e?.message ?? String(e)).join('; '));
    }
    return json.data?.saveHealthPlan;
}

/** Remove a health plan from the business. Gated by BUSINESS_SETTINGS. */
export async function deleteHealthPlan(
    businessId: number | string,
    id: string,
    token: string
): Promise<boolean> {
    const mutation = `
        mutation deleteHealthPlan($businessId: ID!, $id: ID!) {
            deleteHealthPlan(businessId: $businessId, id: $id)
        }
    `;
    const res = await fetch(API_URL, {
        method: "POST",
        headers: headers(token),
        body: JSON.stringify({ query: mutation, variables: { businessId, id } }),
    });
    const json = await res.json();
    if (json.errors) {
        throw new Error(json.errors.map((e: { message?: string }) => e?.message ?? String(e)).join('; '));
    }
    return json.data?.deleteHealthPlan === true;
}
